// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  organizationId: __t.string(),
  name: __t.option(__t.string()),
  workflowName: __t.option(__t.string()),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  nodes: __t.option(__t.string()),
  connections: __t.option(__t.string()),
  pinData: __t.option(__t.string()),
  author: __t.option(__t.string()),
  executionType: __t.option(__t.string()),
  version: __t.option(__t.string()),
  isActive: __t.option(__t.bool()),
  isVisible: __t.option(__t.bool()),
  isOnHomeView: __t.option(__t.bool()),
  requiresAccount: __t.option(__t.bool()),
  userId: __t.option(__t.string()),
  tagIds: __t.option(__t.array(__t.string())),
};
